const calcDohod = (salePrice, price, prWb, upak) => Math.ceil(salePrice - price - salePrice/100*prWb - upak)

export default calcDohod